<template>
  <!-- This template defines the default layout for the app -->
  <div id="app" class="min-vh-100">
    <!-- First insert the navbar region -->
    <NavBar />
    <!-- Then insert the current -->
    <div id="current-page">
      <router-view></router-view>
    </div>
    <!-- And finally insert the footer -->
    <Footer />
  </div>
</template>

<script>
// You must import the components used in the template
import NavBar from "./regions/NavBar";
import Footer from "./regions/Footer";

// And register them as components
export default {
  components: {
    NavBar,
    Footer
  }
};
</script>

<style lang="stylus">
/* Then import your own style */
@import './css/style.styl';
</style>
